'use strict';

var namespace = 'productEdit:';

/**
 * Action types for the variant selection, addition, and modification.
 * @type {Object}
 */
module.exports = {
  MODEL_MATERIAL_SELECTED:    namespace + 'MODEL_MATERIAL_SELECTED',
  MODEL_MATERIAL_DESELECTED:  namespace + 'MODEL_MATERIAL_DESELECTED',
  MODEL_SELECTED:             namespace + 'MODEL_SELECTED',
  VARIANT_SELECTED:           namespace + 'VARIANT_SELECTED',
  VARIANT_DESELECTED:         namespace + 'VARIANT_DESELECTED',
  GET_VARIANT_OPTION_INFO:    namespace + 'GET_VARIANT_OPTION_INFO',
  VARIANT_OPTION_SELECTED:    namespace + 'VARIANT_OPTION_SELECTED',
  VARIANT_OPTION_DESELECTED:  namespace + 'VARIANT_OPTION_DESELECTED',
  PCONF_ACTIVATION_CHANGED:   namespace + 'PCONF_ACTIVATION_CHANGED',
  PCONF_DEFAULT_CHANGED:      namespace + 'PCONF_DEFAULT_CHANGED',
  GET_MODEL_MATERIAL_INFO:    namespace + 'GET_MODEL_MATERIAL_INFO',
  GET_MODEL_INFO:             namespace + 'GET_MODEL_INFO',
  PCONF_PRICING_CHANGED:      namespace + 'PCONF_PRICING_CHANGED',
  GROUP_BY_CHANGED:           namespace + 'GROUP_BY_CHANGED',
  CONTENT_LICENSE_CHANGED:    namespace + 'CONTENT_LICENSE_CHANGED',
  CONTENT_LICENSE_TAG_ENTERED: namespace + 'CONTENT_LICENSE_TAG_ENTERED',
  CONTENT_LICENSE_RESET_ACCEPTANCE: namespace + 'CONTENT_LICENSE_RESET_ACCEPTANCE'
};
